import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class RiskAssessmentProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'riskAssessment'}
            title={'PROCEDURE P16.0 RISK ASSESSMENT'}
            exportTitle={'<h2>Procedure P16.0 Risk Assessment</h2>'}
            exportFileName={'risk_assessment.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (RiskAssessmentProcedure);
